import { CreateList } from "../../Functional/SelectList";

const AddToSelectList = props => {
  const { currentSlide, images, targetListId } = props || {};

  const { archiveId, artworkId } = images[currentSlide];
  const id = `${archiveId},${artworkId}`;

  const createProps = {
    label: "Add to Image Select List",
    typeId: 8,
    ids: [id],
    targetListId,
  };

  return <CreateList {...createProps} />;
};

export default AddToSelectList;
